import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate } from '@pit/core';
import { IDtoLocation } from '../interfaces/dto.location.interface';

// @dynamic
@JsonObject('DtoLocation')
export class DtoLocation extends ModelEntity implements IDtoLocation {

    constructor(initValues: Partial<IDtoLocation> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('accuracy', Number, true)
    public accuracy?: number = null;

    @JsonProperty('latitude', Number, true)
    public latitude?: number = null;

    @JsonProperty('longitude', Number, true)
    public longitude?: number = null;

    @JsonProperty('timestamp', UtilsJsonConverterDate, true)
    public timestamp?: Date = null;

}
